export default "__VITE_ASSET__ClMM8PE8__"